import React from "react";
import UserNavbar from "components/UserNavbar/UserNavbar";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import blogPosts from "./BlogData";

export default function Blog() {
  const navigate = useNavigate();

  // Utility: generate URL‑safe slug from title
  const slugify = (title) =>
    title
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]/g, "");

  return (
    <section className="text-white">
      <UserNavbar />
      <ScrollToTopOnRouteChange />

      <div className="mx-auto my-5 grid max-w-8xl grid-cols-1 gap-4 px-5 sm:px-0 md:grid-cols-2 lg:grid-cols-4">
        {[...blogPosts].reverse().map((post) => {
          const slug = slugify(post.title);
          return (
            <div
              key={post.id}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-md transition-transform hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="overflow-hidden">
                <img
                  src={post.imgsm}
                  alt={post.title}
                  className="h-56 w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col justify-between p-5">
                <div>
                  <h3 className="mb-2 text-xl font-semibold text-gray-900">
                    {post.title}
                  </h3>
                  <p className="line-clamp-3 text-sm text-gray-600">
                    {post.description}
                  </p>
                </div>
                <div
                  onClick={() => navigate(`/blog/${slug}`, { state: post })}
                  className="mt-4 flex cursor-pointer items-center justify-end text-sm font-medium text-red-500 transition-colors hover:text-red-600"
                >
                  <span className="mr-2">Read more</span>
                  <FaArrowRight />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
